import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import routes from '../../../routing/routes';
import mapDate from '../../../function/mapDate';
import PravoEuItem from '../../../model/PravoEuItem';
import './pravoEuListRow.scss';

interface Props {
  pravoEuItem: PravoEuItem;
}

const PravoEuListRow = ({
  pravoEuItem,
}: Props): ReactElement => pravoEuItem && (
<div className="pravo-eu-list-row">
  <Row>
    <Col width="one-third" className="pravo-eu-list-column__third">
      Celex
    </Col>
    <Col width="one-third" className="pravo-eu-list-column__third">
      Dátum uverejnenia
    </Col>
    <Col width="one-third" className="pravo-eu-list-column__third">
      Typ
    </Col>
  </Row>
  <Row className="row-container-pravo-eu-values">
    <Col width="one-third" className="pravo-eu-list-column__third">
      <Text type="div" bold>{pravoEuItem.celex ? pravoEuItem.celex : 'Neuvedený'}</Text>
    </Col>
    <Col width="one-third" className="pravo-eu-list-column__third">
      <Text type="div" bold>{pravoEuItem.datumUverejnenia ? mapDate(pravoEuItem.datumUverejnenia) : 'Neuvedený'}</Text>
    </Col>
    <Col width="one-third" className="pravo-eu-list-column__third">
      <Text type="div" bold>{pravoEuItem.typ ? pravoEuItem.typ : 'Neuvedený'}</Text>
    </Col>
  </Row>
  <Row className="nazov-link-container">
    <Col width="full">
      <Link
        className="nazov-link"
        to={routes.pravoEu.detail.withParams(pravoEuItem.uuid)}
      >
        {pravoEuItem.nazov}
      </Link>
    </Col>
  </Row>

</div>
);

export default PravoEuListRow;
